import { useState } from "react";
import { toast } from "react-toastify";

export const useEmail = () => {
  const [isSending, setIsSending] = useState(false);

  const sendEmail = (emailMsg, subject) => {
    setIsSending(true);

    const formData = new FormData();
    const licno = "DSTDEMO";

    formData.append("licno", licno);
    formData.append("email", "rnalawchambers@gmail.com");
    formData.append("Subject", subject);
    formData.append("Content", emailMsg);

    const toastId = toast.loading("📤 Sending...");

    // ✅ Immediately show success toast with shorter auto close
    toast.update(toastId, {
      render: "Thank you! We will get back to you shortly.",
      type: "success",
      isLoading: false,
      autoClose: 1500,
      closeOnClick: true
    });

    fetch("https://Custommail.dynode.in/api/mail/sendmail", {
      method: "POST",
      body: formData,
      headers: { "Accept": "application/json, text/plain, */*" },
    })
      .then(async (response) => {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          await response.json();
        } else {
          await response.text();
        }
      })
      .catch(() => {
        toast.error("❌ Failed to send message. Please try again.", {
          autoClose: 1500,
          closeOnClick: true
        });
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return { sendEmail, isSending };
};
